$(document).ready(function() {
	if(!document.querySelector('.GPC0147')) return false;
	var $component = $(".GPC0147");
	var countryCode = $('html').data('countrycode');
	
	/* 파라미터로 입력된 QR코드가 적절하지 않으면 메인페이지로 redirect  */
	var hiddenQRCode = getParameterByName('hiddenQRCode');
	var configQRCode = $component.find('#confQRCode').val();
	
	/* E-Studio Preview에서 Redirection 안 되도록 설정 */
	if(window.location.href.indexOf('dev50.cms.lg.com') < 0 && window.location.href.indexOf('admin50.cms.lg.com') < 0) {
		if(hiddenQRCode != configQRCode){
			window.location.href = "/"+countryCode;
		}
	}
	
	/*// 파라미터로 입력된 QR코드가 적절하지 않으면 메인페이지로 redirect */
	/* url 파라미터 제거*/
	history.replaceState({}, null, location.pathname);
	setTimeout(function() {
		var token = sessionStorage.getItem('ACCESS_TOKEN');
		if(token) {
			$component.find('.pr-hidden-box')[0].className += ' check';
		}
	}, 100);
	
	$component.find(".member .btn-area .btn").on("click", function(e){
		var copyText = $component.find('.member .code-box .code').text();
		Clipboard.copy(copyText);
	});
	
	// Make it easier to find ID values ​​in the teamsite edit screen
	window.Clipboard = (function (window, document, navigator) {
		var textArea,
			copy;

		function isOS() {
			return navigator.userAgent.match(/ipad|iphone/i);
		}

		function createTextArea(text) {
			textArea = document.createElement('textArea');
			textArea.value = text;
			textArea.style.position = 'fixed';
			textArea.style.top = '0';
			textArea.style.left = '0';
			textArea.style.opacity = '0.0001';
			textArea.style.width = '100%';
			textArea.style.height = '100%';
			textArea.style.padding = '0';
			textArea.style.pointerEvents = "none";
			textArea.style.fontSize = '16px';
			document.body.appendChild(textArea);
		}

		function selectText() {
			var range,
				selection;

			if (isOS()) {
				range = document.createRange();
				range.selectNodeContents(textArea);
				selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange(range);
				textArea.setSelectionRange(0, 999999);
			} else {
				textArea.select();
			}
		}

		function copyToClipboard() {
			document.execCommand('copy');
			document.body.removeChild(textArea);
		}

		copy = function (text) {
			createTextArea(text);
			selectText();
			copyToClipboard();
		};
		return {
			copy: copy
		};
	})(window, document, navigator);
	
	function getParameterByName(name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	        results = regex.exec(location.search);
	    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
});